module.exports = __webpack_public_path__ + "img/2.8912a4f5.png";